<template>
  <div class="animated fadeIn">
    <div class="kt-portlet kt-portlet--mobile" style="position:relative">
      <div class="kt-portlet__body kt-portlet__body--fit" ref="cnt">
        <div class="m-4">
          <div class="filters-container">
            <TableFilters v-model="filterOptions" style="margin-right: 45px" @click="refresh" />
            <DropdownColumns
              :fields="[]"
              class="customize"
              :export-link="exportLink"
              :export-json="exportJson"
            />
          </div>
          <div style="overflow:auto" class="mt-2">
            <b-table
              id="cash-required-table"
              :busy.sync="isBusy"
              show-empty
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :hover="true"
              :striped="true"
              v-model="copy"
              :items="provider"
              :fields="fields"
              :current-page="currentPage"
              :per-page="perPage"
              @row-clicked="rowClicked"
              tbody-tr-class="tr-pointer"
              v-columns-resizable="{ afterResize: columnsWidthChanged }"
            >
              <template v-slot:head(shop_code)="data">{{ $t(data.label) }}</template>
              <template v-slot:head(shop_name)="data">{{ $t(data.label) }}</template>
              <template v-slot:head(current_balance)="data">{{ $t(data.label) }}</template>
              <template v-slot:head(current_unclaimed_winnings)="data">
                {{
                $t(data.label)
                }}
              </template>
              <template v-slot:head(pending_casino_withdrawals)="data">{{ $t(data.label) }}</template>
              <template v-slot:head(difference)="data">{{ $t(data.label) }}</template>
              <template v-slot:head(cutn)="data">{{ $t(data.label) }}</template>

              <template v-slot:cell(shop_code)="data">
                <span v-if="data.value">
                  <span v-if="data.value.to">
                    <router-link :to="`/shops/${data.value.to}`">{{ data.value.name }}</router-link>
                  </span>
                  <span v-else>{{ data.value.name }}</span>
                </span>
              </template>

              <template v-slot:cell(shop_name)="data">
                <span v-if="data.value">
                  <span v-if="data.value.to">
                    <router-link :to="`/shops/${data.value.to}`">{{ data.value.name }}</router-link>
                  </span>
                  <span v-else>{{ data.value.name }}</span>
                </span>
              </template>

              <template v-slot:cell(current_balance)="data">
                {{
                roundThousands(data.value)
                }}
              </template>
              <template v-slot:cell(current_unclaimed_winnings)="data">
                {{
                roundThousands(data.value)
                }}
              </template>
              <template v-slot:cell(pending_casino_withdrawals)="data">
                {{
                roundThousands(data.value)
                }}
              </template>
              <template v-slot:cell(difference)="data">
                <span :class="{ 'text-danger': data.value < 0 }">
                  {{
                  roundThousands(data.value)
                  }}
                </span>
              </template>
              <template v-slot:cell(current_unclaimed_tickets)="data">
                <span v-if="data.value">{{ data.value }}</span>
                <span v-else>0</span>
              </template>

              <template v-slot:empty="scope">
                <div class="text-center">{{ $t(scope.emptyText) }}</div>
              </template>
            </b-table>
          </div>
          <div class="container-fluid">
            <div class="row">
              <div style="white-space:nowrap;" class="my-2">
                <PaginationSelect
                  v-model="perPage"
                  :options="paginationOpts"
                  variant="light"
                  size="sm"
                />
                <span>
                  &nbsp;
                  <i18n path="Showing {start}-{end} of {total} rows" tag="span">
                    <span slot="start">{{ (currentPage - 1) * perPage + 1 }}</span>
                    <span slot="end">{{ currentPage * perPage }}</span>
                    <span slot="total">{{ totalRows }}</span>
                  </i18n>
                </span>
                <b-button
                  size="sm"
                  @click.stop="$root.$emit('bv::refresh::table', 'cash-required-table')"
                  class="ml-2 refresh"
                  variant="light"
                  :title="$t('Refresh')"
                >
                  <i class="icon-refresh"></i>
                </b-button>
              </div>
              <nav class="ml-auto mt-2">
                <b-pagination
                  size="md"
                  :total-rows="totalRows"
                  :per-page="perPage"
                  v-model="currentPage"
                />
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import startCase from "@/shared/strings";
import { errorConf } from "@/shared/notifications";
import tableMixin from "@/shared/mixins/table.mixin";
import PaginationSelect from "@/components/PaginationSelect";
import DropdownColumns from "@/components/DropdownColumns";
import TableFilters from "@/components/TableFilters";

export default {
  name: "cashRequired",
  mixins: [tableMixin],
  components: {
    PaginationSelect,
    DropdownColumns,
    TableFilters
  },
  data: function() {
    return {
      tableName: "cashRequired",
      filterOptions: [
        {
          field: "company_id",
          multiple: true,
          placeholder: "Company",
          trackBy: "eid",
          label: "name",
          translate: false,
          store: "companies",
          hide_select: true,
          filterOptions: ["tenant_id"],
          options: [],
          selected: [],
          postIgnore: true
        },
        {
          field: "tenant_id",
          multiple: true,
          placeholder: "Tenant",
          trackBy: "eid",
          label: "brand_name",
          translate: false,
          store: "tenants",
          hide_select: true,
          filterOptions: ["shopgroup_id", "shop_id"],
          options: [],
          originalOptions: [],
          selected: [],
          postIgnore: true,
          filterOptionsBy: (data, field, fieldValue) => {
            const selected = fieldValue.map(elem => elem.eid);
            const orig = data.list[1].originalOptions;
            if (
              selected.length == 0 &&
              data.list[1].options.length != orig.length
            ) {
              data.list[1].options = orig;
            } else if (selected.length != 0) {
              data.list[1].options = orig.filter(item => {
                if (selected.indexOf(item.ecompany_id) > -1) {
                  return true;
                }
                return false;
              });
            }
          }
        },

        {
          field: "shopgroup_id",
          multiple: true,
          placeholder: "Shop Group",
          trackBy: "eid",
          label: "name",
          translate: false,
          store: "shopGroups",
          hide_select: true,
          options: [],
          originalOptions: [],
          selected: [],
          filterOptions: ["shop_id"],
          postIgnore: true,
          filterOptionsBy: (data, field, fieldValue) => {
            const selected = fieldValue.map(elem => elem.eid);
            const index = 2;
            const orig = data.list[index].originalOptions;
            if (selected.length == 0) {
              data.list[index].options = orig;
            } else {
              data.list[index].options = orig.filter(item => {
                if (selected.indexOf(item.etenant_id) > -1) {
                  return true;
                }
                return false;
              });
            }
          }
        },
        {
          field: "shop_id",
          multiple: true,
          placeholder: "Shop",
          trackBy: "eid",
          label: "name",
          translate: false,
          store: "shops",
          hide_select: true,
          options: [],
          originalOptions: [],
          selected: [],
          filterOptionsBy: (data, field, fieldValue) => {
            let selectedTenants = [];
            let selectedShopGroups = [];

            if (field == "tenant_id") {
              selectedTenants = fieldValue.map(elem => elem.eid);
            } else {
              selectedTenants = data.list[0].selected.map(elem => elem.eid);
            }
            if (field == "shopgroup_id") {
              selectedShopGroups = fieldValue.map(elem => elem.eshop_ids);
              if (selectedShopGroups.length) {
                selectedShopGroups = [].concat.apply([], selectedShopGroups);
              }
            } else {
              selectedShopGroups = data.list[2].selected.map(
                elem => elem.eshop_ids
              );
              if (selectedShopGroups.length) {
                selectedShopGroups = [].concat.apply([], selectedShopGroups);
              }
            }
            const index = 3;
            const orig = data.list[index].originalOptions;

            if (!selectedTenants.length && !selectedShopGroups.length) {
              data.list[index].options = orig;
            } else {
              let tmp = [];

              if (selectedTenants.length) {
                tmp = orig.filter(item => {
                  if (selectedTenants.indexOf(item.etenant_id) > -1) {
                    return true;
                  }
                  return false;
                });
              }

              if (selectedShopGroups.length) {
                if (!selectedTenants.length && !selectedTenants.length) {
                  tmp = orig;
                }
                tmp = tmp.filter(item => {
                  if (selectedShopGroups.indexOf(item.eid) > -1) {
                    return true;
                  }
                  return false;
                });
              }
              data.list[index].options = tmp;
            }
          }
        }
      ],
      isBusy: false,
      sortBy: "",
      sortDesc: true,
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      filter: null,
      filterField: null,
      checkAll: false,
      copy: null,
      addLabel: ""
    };
  },
  computed: {
    fields() {
      const columns = [
        {
          key: "shop_code",
          label: "Shop Code",
          sortable: false,
          ignore: true,
          class: ""
        },
        {
          key: "shop_name",
          label: "Shop Name",
          sortable: false,
          ignore: true,
          class: ""
        },
        {
          key: "current_balance",
          label: "Current Balance",
          sortable: true,
          ignore: true,
          class: ""
        },
        {
          key: "current_unclaimed_winnings",
          label: "Current Unclaimed Winnings",
          sortable: true,
          ignore: true,
          class: ""
        },
        {
          key: "pending_casino_withdrawals",
          label: "Pending Casino Withdrawals",
          sortable: true,
          ignore: true,
          class: ""
        },
        {
          key: "difference",
          label: "Difference",
          sortable: true,
          ignore: true,
          class: ""
        },
        {
          key: "current_unclaimed_tickets",
          label: "# U. Tickets",
          headerTitle: this.$t("Unclaimed Tickets Number"),
          sortable: true,
          ignore: true,
          class: ""
        }
      ];
      return columns;
    },
    lang() {
      return this.$store.getters["global/defLanguage"];
    },
    exportLink() {
      const apiUrl = this.$store.getters["global/apiUrl"];
      const endpoint = this.$store.getters["cashRequired/endpoint"];

      return `${apiUrl}/${endpoint}?export=xls&lang=${this.lang}`;
    },
    exportJson() {
      const fields = [];
      this.fields.forEach(item => {
        if (
          typeof item.class != "undefined" &&
          item.class.indexOf("d-none") == -1
        ) {
          let key = item.key;
          if (key != "selected") {
            const efields = ["eshop_id"];

            if (efields.indexOf(key) > -1) {
              key = key.substr(1);
            }

            fields.push(key);
          }
        }
      });

      const paginationData = this.buildPagination();

      paginationData.fields = fields;

      return JSON.stringify(paginationData);
    }
  },
  methods: {
    refresh() {
      this.$root.$emit("bv::refresh::table", "cash-required-table");
    },
    provider(ctx, callback) {
      const loading = this.$loading.open({
        container: this.$refs.cnt
      });

      const paginationData = this.buildPagination();

      const shopByID = this.$store.getters["cache/shopByID"];

      Promise.all([
        this.$store.dispatch("cache/fetch", "shops").catch(e => e)
      ]).finally(() => {
        this.$store
          .dispatch("cashRequired/fetch", paginationData)
          .then(resp => {
            this.totalRows = resp.data.total;
            resp.data.rows.forEach((item, index) => {
              if (item.eshop_id) {
                const shop = shopByID(item.eshop_id);
                if (shop) {
                  item.shop_name = {
                    to: item.eshop_id,
                    name: shop.name
                  };
                  item.shop_code = {
                    to: item.eshop_id,
                    name: shop.code
                  };
                } else {
                  item.shop_name = {
                    to: item.eshop_id,
                    name: item.eshop_id
                  };
                  item.shop_code = {
                    to: item.eshop_id,
                    name: item.eshop_id
                  };
                }
              }
            });
            callback(resp.data.rows);
          })
          .catch(err => {
            this.$bvToast.toast(
              this.$t(
                err.details && err.details.length ? err.details[0] : err.message
              ),
              errorConf(this.$t("Error"))
            );
            this.totalRows = 0;
            callback([]);
          })
          .finally(() => {
            loading.close();
          });
      });

      // Must return null or undefined to signal b-table that callback is being used
      return null;
    },
    buildPagination() {
      const paginationData = {
        rowsPerPage: this.perPage,
        page: this.currentPage
      };

      if (this.filter && this.filterField) {
        paginationData.likeValues = [this.filter];
        paginationData.likeFields = [this.filterField];
      } else {
        paginationData.likeValues = [];
        paginationData.likeFields = [];
      }

      if (this.sortBy) {
        paginationData.sortBy = [this.sortBy];
        paginationData.sortDirection = [this.sortDesc ? "DESC" : "ASC"];
      }

      const exactFields = [];
      const exactValues = [];

      this.filterOptions.forEach(item => {
        if (item.type != "date" && item.selected.length && !item.postIgnore) {
          exactFields.push(item.field);
          if (item.trackBy) {
            const tmp = [];
            item.selected.forEach(el => {
              tmp.push(el[item.trackBy]);
            });
            exactValues.push(tmp);
          } else {
            exactValues.push(item.selected);
          }
        } else if (item.type == "date") {
          if (item.selected.startDate && item.selected.endDate) {
            paginationData.dateField = item.field;
            paginationData.dateStart = item.selected.startDate;
            paginationData.dateEnd = item.selected.endDate;
          } else {
            paginationData.dateField = item.field;
            paginationData.dateStart = moment().startOf("month");
            paginationData.dateEnd = moment().endOf("month");
          }
        }
      });

      if (exactFields.length) {
        paginationData.exactFields = exactFields;
        paginationData.exactValues = exactValues;
      }

      return paginationData;
    },
    rowClicked(item, index, event) {},
    redirect() {}
  }
};
</script>

<style lang="scss" scoped></style>
